import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from '../../shared/canonical.service';


@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {

  heading = "Customers";
  subheading = "Our customers trust innovative products to provide mobile and app security";
  innerWidth:number = window.innerWidth;

  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta, private canonicalService: CanonicalService) {
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/customers");
   }

  ngOnInit(): void {
    this.titleService.setTitle('Customers | Mobile App Security | Protectt.ai');
    this.metaTagService1.updateTag({ name: 'title', content: 'Our Product Partners & Customers | Protectt.ai'});
    this.metaTagService.updateTag({ name: 'description', content: 'Our promise to work, innovativeness & zeal to deliver excellence to secure our customer mobile device. Our happy and cyber secure customers are the reason to our success stories.'});
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
